export interface CreatePagerDutyIncidentParams {
  userEmail: string;
  projectId?: string;
  environmentId?: string;
  currentUrl: string;
  additionalDescription?: string;
}

export async function createPagerDutyIncidentWithModal(
  params: Omit<CreatePagerDutyIncidentParams, "additionalDescription">,
) {
  const { displayPagerDutyIncidentModal } = await import(
    "@/components/modal/pagerduty-incident-modal"
  );

  try {
    const defaultDescription = "";
    const incidentDetails = await displayPagerDutyIncidentModal({
      defaultDescription,
    });

    if (incidentDetails) {
      return createPagerDutyIncidentRequest({
        ...params,
        additionalDescription: incidentDetails.description,
      });
    }
    return null;
  } catch (error) {
    // User hit cancel on the modal
    return null;
  }
}

export function createPagerDutyIncidentRequest(params: CreatePagerDutyIncidentParams) {
  const contextDetails = [
    `User: ${params.userEmail}`,
    `Project ID: ${params.projectId || "Unknown"}`,
    `Environment ID: ${params.environmentId || "Unknown"}`,
    `Current Page: ${params.currentUrl}`,
    "",
    "User requested immediate support via Chalk dashboard.",
    ...(params.additionalDescription
      ? ["", "Additional Details:", params.additionalDescription]
      : []),
  ].join("\n");

  return {
    incident: {
      type: "incident",
      title: `Support Requested from this link: ${params.currentUrl}`,
      service: {
        id: "P4TIFGQ",
        type: "service_reference",
      },
      urgency: "high",
      body: {
        type: "incident_body",
        details: contextDetails,
      },
    },
  };
}
